<template>
  <v-dialog v-model="dialog" max-width="400px" scrollable>
    <v-card
      style="border-radius:20px;"
      class="py-2 strategio-card-container"
    >
      <v-card-title class="layout py-2 justify-center"
        style="font-size:20px;"
      >
        <span class="headline py-0" style="font-weight:500;">{{ title }}</span>
        <span class="flex text-xs-right py-0">{{ subtitle }}</span>
      </v-card-title>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-text>
        <span class="caption">{{ message }}</span>
        <v-container grid-list-md>
          <div class="body-2 mt-1">En tarjetas</div>
          <v-layout column>
            <v-flex :key="index" v-for="(item, index) in body.card">
              <v-layout align-center>
                <v-flex>
                  <img slot="activator" height="20px" :src="require('@/' + item.color.iconPath)" alt="indicator-icon">
                </v-flex>
                <v-flex xs12>
                  <span>{{ item.description }}</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <div class="body-2 mt-3">En detalle</div>
          <v-layout column>
            <v-flex :key="index" v-for="(item, index) in body.detail">
              <v-layout align-center>
                <v-flex>
                  <img slot="activator" height="20px" :src="require('@/' + item.color.iconPath)" alt="indicator-icon">
                </v-flex>
                <v-flex xs12>
                  <span>{{ item.description }}</span><v-spacer></v-spacer>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

        </v-container>

      </v-card-text>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-actions class="v-layout justify-center">
        <v-btn
          small depressed rounded dark
          class="strategio-dialog-button"
          color="error"
          @click.native="accept()"
        >Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventBus from '../../utils/eventBus'
export default {
  name: 'show-card-details-dialog',
  created () {
    eventBus.$off('open-details-dialog')
    eventBus.$on('open-details-dialog', (data) => {
      this.dialog = true
      this.title = data.title
      this.subtitle = data.subtitle
      this.message = data.message
      this.body = data.body
    })
  },
  data () {
    return {
      dialog: false,
      // dialog: true,
      title: '',
      subtitle: '',
      message: '',
      body: []
    }
  },
  methods: {
    accept () {
      this.dialog = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/show-card-details-dialog.vue